import axios from 'axios';

import { getAuthorizationHeader } from './auth_service';

export const reportProblem = async (body) => {
  let res = await axios.post(
    process.env.REACT_APP_BACKEND_URL + `api/cases/`,
    { data: {...body, account: localStorage.getItem("accountId") } },
    getAuthorizationHeader()
  );

  return res.data.data
};


export const getCaseList = async () => {
  let res = await axios.get(process.env.REACT_APP_BACKEND_URL + `api/cases?filters[account]=${localStorage.getItem("accountId")}&populate=*&sort[1]=updatedAt%3Adesc`, getAuthorizationHeader())
  return res;
};

export const getCase = async (opt = {}, caseId) => {
  let url = `api/cases/${caseId}?populate=*`
  
  if(opt.getDocUrl) {
    url = `api/cases/${caseId}?populate[documents][populate]=*&populate=account`
  }

  let res = await axios.get(process.env.REACT_APP_BACKEND_URL + 
      url, getAuthorizationHeader())
  return res.data.data;
};
